import courseLabels from "common/entities/courseWrapper/labels";
import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	...courseLabels.getData(),

	ProgramNotFoundTitle: {
		k: "program.notfound.title",
		v: "Program Not Found"
	},

	ProgramNotFoundDesc: {
		k: "program.notfound.desc",
		v: ""
	},

	ProgramsEmptyTitle: {
		k: "programs.empty.title",
		v: "No Programs Found"
	},

	ProgramsEmptyDesc: {
		k: "programs.empty.desc",
		v: "Try different search parameters"
	},

	TracksEmptyTitle: {
		k: "program.tracks.empty.title",
		v: "No Tracks Found"
	},

	TracksEmptyDesc: {
		k: "program.tracks.empty.desc",
		v: ""
	},

	ProductsEmptyTitle: {
		k: "track.products.empty.title",
		v: "No Courses Found"
	},

	ProductsEmptyDesc: {
		k: "track.products.empty.desc",
		v: ""
	},

	TracksTitle: {
		k: "program.tracks",
		v: "Tracks"
	},

	TracksSectionTitle: {
		k: "program.section.tracks.title",
		v: "2. Study & Practice"
	},

	TracksSectionSubTitle: {
		k: "program.section.tracks.subtitle",
		v: "Complete the Curriculum"
	},

	TracksSectionStats: {
		k: "program.section.tracks.count",
		v: "${completed} / ${total} Courses Completed",
		argNames: ["completed", "total"]
	},

	Weaknesses: {
		k: "program.weaknesses.legend",
		v: "Focus based on Self-Assessment"
	},

	CompletedOn: {
		k: "completedOn",
		v: "Completed On ${date}",
		argNames: ["date"]
	},

	Score: {
		k: "score",
		v: "Score: ${score}",
		argNames: ["score"]
	},

	BadgeIssuedAt: {
		k: "badge.issuedAt",
		v: "Claimed ${date}",
		argNames: ["date"]
	},

	BadgeClaim: {
		k: "badge.claim",
		v: "Claim Badge"
	},

	BadgeExpires: {
		k: "badge.expires",
		v: "Badge Expires: ${expiresAt}",
		argNames: ["expiresAt"]
	}

});



// WEBPACK FOOTER //
// ./src/panels/program/Program.labels.ts